import { render, staticRenderFns } from "./customer-label-statistics.vue?vue&type=template&id=6a03565a&scoped=true&"
import script from "./customer-label-statistics.vue?vue&type=script&lang=js&"
export * from "./customer-label-statistics.vue?vue&type=script&lang=js&"
import style0 from "./customer-label-statistics.vue?vue&type=style&index=0&id=6a03565a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a03565a",
  null
  
)

export default component.exports